module.exports = __webpack_public_path__ + "img/u5.f44eef9b.png";